import { useEffect, useState } from 'react';
import { useAgentTeam } from '@/common/hooks/useAgentTeam/useAgentTeam';
import { formatAddress } from '@/common/utils/address';
import { mailingAddressHasValidGeolocation } from '@/views/Community/views/PartnerMap/utils/location';
import type { Location } from '../../../../CommunityListings.state';

export type DropdownOption = Location & {
  group?: string;
  optionType?: string;
  parentId?: string;
};

export function useDefaultOptions() {
  const { team } = useAgentTeam();
  const officeAddress = team?.registeredAddress;
  const [currentLocationOption, setCurrentLocationOption] =
    useState<DropdownOption | null>(null);

  useEffect(() => {
    const initCurrentLocationOption = () => {
      if (!navigator.geolocation) return;

      navigator.geolocation.getCurrentPosition(({ coords }) => {
        setCurrentLocationOption({
          id: 'currentLocation',
          label: 'Current Location',
          latitude: coords.latitude,
          longitude: coords.longitude,
        });
      });
    };

    initCurrentLocationOption();
  }, []);

  const options: DropdownOption[] = [];

  if (currentLocationOption) {
    options.push(currentLocationOption);
  }

  if (mailingAddressHasValidGeolocation(officeAddress)) {
    options.push({
      id: 'primaryOffice',
      label: formatAddress({
        street1: officeAddress.street1,
        city: officeAddress.city,
        state: officeAddress.state,
        zip: officeAddress.postalCode,
      }),
      secondaryLabel: 'Primary Office Location',
      latitude: Number(officeAddress.geolocationLatitude),
      longitude: Number(officeAddress.geolocationLongitude),
    });
  }

  return options;
}
